module.exports = __webpack_public_path__ + "img/image-site-maroc.9ade7430.jpg";